import React from "react";
import bg from "../../images/renaturer.png";

const GallyRenaturer = () => {
  return (
    <div>
      <section
        className="p-4 text-center sm:p-6 md:p-10 lg:p-20 bg-black/70 bg-blend-overlay"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-xl font-bold text-center text-white sm:text-2xl md:text-3xl">
          Renaturer le ruisseau
        </h1>
        <div className="flex justify-center mt-4 sm:mt-6">
          <p className="max-w-3xl text-base text-white">
            Vers un Ru de Gally Plus Naturel et Résilient
          </p>
        </div>
      </section>
      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-20 sm:px-6 lg:px-8">
        <h2 className="text-xl font-bold text-center text-black">
          Végétaliser les berges
        </h2>
        <div className="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <p className="text-base">
              Malgré une nette amélioration de son état environnemental ces
              dernières années, le ru de Gally reste marqué par l’activité
              humaine et la pollution. On trouve notamment dans ses eaux des
              traces de nitrates et de matières phosphatées, issus
              respectivement de l’agriculture intensive et de produits ménagers.
              Les rivières disposent de capacités « d’auto-épuration » grâce à
              une végétation spécifique. Celle-ci avait en grande partie disparu
              le long du ru de Gally. Peu à peu,{" "}
              <span className="text-primary">HYDREAULYS</span> réintroduit{" "}
              <span className="text-primary">ces arbres de berge</span>,
              indispensables pour « pomper » la pollution et redonner vie aux
              différents habitats naturels d’une rivière.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src={bg}
              alt="Renaturation of Ru de Gally"
              className="w-full h-auto max-w-xs rounded-lg sm:max-w-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GallyRenaturer;
